export const exist = (data: string[] = [], id: string) =>
  !!data.find((item: string) => {
    return item === id
  })

export const removeItem = (arr: any, item: any) => {
  const idx = arr.indexOf(String(item))
  if (idx > -1) {
    arr.splice(idx, 1)
  }
  return arr
}
